export const SCRIPT_COMMENTARY_MODE_OPTIONS = [
  { value: 0, label: '精品剧' },
  { value: 1, label: '解说漫' },
  { value: 2, label: '社媒剧' },
]

// 社媒剧由外部 APP 接入，平台创建只接受精品剧和解说漫。
export const PLATFORM_SCRIPT_COMMENTARY_MODE_OPTIONS = SCRIPT_COMMENTARY_MODE_OPTIONS.filter(item => item.value !== 2)

export function getScriptCommentaryMode(data) {
  const value = data && typeof data === 'object'
    ? data.commentaryMode ?? data.commentary_mode
    : data
  if (value === 2 || value === '2') return 2
  if (value === true || value === 1 || value === '1') return 1
  return 0
}

export function getScriptCommentaryModeLabel(data) {
  const mode = getScriptCommentaryMode(data)
  return SCRIPT_COMMENTARY_MODE_OPTIONS.find(item => item.value === mode).label
}
